module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEUAAAAQCAYAAABAzrJtAAAAbklEQVRYhe3WQQrAIAxE0ab0/leuZiHEMCK4iTDzdu1KPmhif/fI5K0+wI0UBVAU4Ks+QBUzm77j00oZxYPk+RL/6foAlFF2WwhllCxfJ/oo6H2hjoKCONooqyCOMspqJA+Ue4rLy1tEGUUj+UADtIciJHgoDWUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/zbtb1-1.png
// module id = 731
// module chunks = 0